import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';

/** Blocks access in production builds — only allows dev/local environments. */
export const devOnlyGuard: CanActivateFn = () => {
  if (!environment.production) {
    return true;
  }
  return inject(Router).createUrlTree(['/']);
};
